export const convertMultipleIds = (params, key, hasQuery = false) => {
    let queryString = !hasQuery ? '?' : ''
    params[key].forEach(item => {
        if (item) {
            queryString += `&${key}=${item}`
        }
    })
    return queryString
}

export const validateQueryStringParameters = (params) => {
    const data = {}

    Object.keys(params).forEach(item => {
        const param = params[item]

        if (Array.isArray(param) && param.length) {
            data[item] = param
        } else if (typeof param === 'string' && param) {
            data[item] = param
        } else if (typeof param !== 'string' && !Array.isArray(param) && param) {
            data[item] = param
        }

    })

    return data
}

export const convertToQueryString = (params) => {
    const query = validateQueryStringParameters(params)
    let queryString = '?'
    Object.keys(query).forEach(item => {
        const queryItem = query[item]
        if (Array.isArray(queryItem)) {
            queryItem.forEach(x => {
                queryString += `&${item}=${x}`
            })
        } else {
            queryString += `&${item}=${queryItem}`
        }
    })
    return params
}
